import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.531 16.563H2.906A1.406 1.406 0 0 1 1.5 15.155V3.906A1.406 1.406 0 0 1 2.906 2.5h16.875a1.406 1.406 0 0 1 1.407 1.406v8.438M1.845 2.987l7.604 5.812a2.813 2.813 0 0 0 3.789 0l7.603-5.812m-3.872 10.06 5.625 4.219-5.625 4.218v-2.109H12.75a1.407 1.407 0 0 1-1.406-1.406v-1.407a1.406 1.406 0 0 1 1.406-1.406h4.219v-2.11Z",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M8.531%2016.563H2.906A1.406%201.406%200%200%201%201.5%2015.155V3.906A1.406%201.406%200%200%201%202.906%202.5h16.875a1.406%201.406%200%200%201%201.407%201.406v8.438M1.845%202.987l7.604%205.812a2.813%202.813%200%200%200%203.789%200l7.603-5.812m-3.872%2010.06%205.625%204.219-5.625%204.218v-2.109H12.75a1.407%201.407%200%200%201-1.406-1.406v-1.407a1.406%201.406%200%200%201%201.406-1.406h4.219v-2.11Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
